module.exports = __webpack_public_path__ + "img/blue-bank.34fe47da.svg";